module.exports = __webpack_public_path__ + "static/img/jp8.10fc9db9.png";